import { createContext } from "react";

import { HomeContext } from "./home.types";

export const homeContext = createContext<HomeContext>({
  observe() {},
  sendEvent() {},
  unobserve() {},
});
